import { useState } from 'react'

import copy from '../../demo/fixtures/w5/copy.json'
import { PageHeader } from '../../app/PageHeader'
import { Button, Icon, Toast, ToastHost } from '../../ui'
import { useW5Live } from '../analysis/live'
import { BenchmarkCard } from './BenchmarkCard'
import { GuardChips } from './GuardChips'
import { PendingApprovalCard } from './PendingApprovalCard'
import { NewRuleDialog } from './NewRuleDialog'
import { ProposalDecisionDialog, type ProposalDialogState } from './ProposalDecisionDialog'
import { RuleGroups } from './RuleGroups'
import { TriggerLog } from './TriggerLog'
import styles from './AutomationPage.module.css'

export function AutomationPage() {
  const page = copy.pages.automation
  const { automation } = useW5Live()
  const [newRuleOpen, setNewRuleOpen] = useState(false)
  const [proposalRequest, setProposalRequest] = useState<ProposalDialogState | null>(null)
  const [toast, setToast] = useState<string | null>(null)

  return (
    <>
      <PageHeader
        title={page.title}
        subtitle={page.subtitle}
        action={
          <div className={styles.headerActions}>
            <span className={styles.checkChip}>
              <Icon name="clock" size={15} />
              {copy.nextCheckLabel}
            </span>
            <Button className={styles.newRuleButton} onClick={() => setNewRuleOpen(true)}>
              <Icon name="plus-circle" size={15} />
              {copy.sections.newRule}
            </Button>
          </div>
        }
      />
      <div className={styles.body}>
        <PendingApprovalCard onDecide={setProposalRequest} />
        <div className={styles.columns}>
          <div className={styles.primaryColumn}>
            <RuleGroups />
            <TriggerLog />
          </div>
          <BenchmarkCard />
        </div>
        <GuardChips />
      </div>
      {newRuleOpen ? <NewRuleDialog open groupOrder={automation.groupOrder} onClose={() => setNewRuleOpen(false)} onDone={setToast} /> : null}
      {proposalRequest ? <ProposalDecisionDialog open {...proposalRequest} onClose={() => setProposalRequest(null)} onDone={setToast} /> : null}
      {toast ? <ToastHost><Toast onDismiss={() => setToast(null)}>{toast}</Toast></ToastHost> : null}
    </>
  )
}
